<div class="dialog-header">
  <p>{{ adminMode ? 'Editing' : 'Viewing' }} {{ documentTitle }}</p>
  <button mat-dialog-close mat-icon-button aria-label="Close dialog" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="metadata-dialog">
  <!-- View Mode -->
  <table class="metadata-table" *ngIf="!adminMode">
    <tbody>
      <tr *ngFor="let item of filteredDimensions | keyvalue">
        <td>{{ item.key | titlecase }}:</td>
        <td>{{ item.value }}</td>
      </tr>
    </tbody>
  </table>

  <!-- Edit Mode -->
  <div class="edit-form" *ngIf="adminMode">
    <div *ngFor="let item of filteredDimensions | keyvalue" class="form-field">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ item.key | titlecase }}</mat-label>
        <input matInput [(ngModel)]="editableValues[item.key]" [placeholder]="item.value" type="text" />
      </mat-form-field>
    </div>
  </div>
</div>

<!-- Admin Mode Action Buttons -->
<div class="dialog-actions" *ngIf="adminMode">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button (click)="onSave()">Save</button>
</div>
